export default "__VITE_ASSET__C9UseXO5__"